/*
 * THIS FILE WAS GENERATED BY "@atproto/lex". DO NOT EDIT.
 */

export * as defs from './labeler/defs'
export * as getServices from './labeler/getServices'
export * as service from './labeler/service'
